export interface SearchIdentity {
  source_node_id: string;
  action_type: string;
  query_type: string;
  query_value?: string;
  image_url?: string;
  ai_mode?: string;
}

function normalizeSearchValue(value: unknown, type: string): string {
  const text = String(value ?? '').trim();
  if (type === 'phone') return text.replace(/\D/g, '');
  if (type === 'image') return text;
  return text.replace(/\s+/g, ' ').toLowerCase();
}

export function isSearchCompleted(history: any[], search: SearchIdentity): boolean {
  const value = normalizeSearchValue(search.query_type === 'image' ? search.image_url || search.query_value : search.query_value, search.query_type);
  if (!value || !search.source_node_id) return false;
  return (history || []).some(action => action.status === 'completed' &&
    action.source_node_id === search.source_node_id && action.action_type === search.action_type &&
    action.query_type === search.query_type && (!search.ai_mode || action.ai_mode === search.ai_mode) &&
    normalizeSearchValue(search.query_type === 'image' ? action.image_url || action.query_value : action.query_value, search.query_type) === value);
}
